/** BCP-47 locale tags supported by Patient Watch. */
export type SupportedLocale = "en-GB" | "en-US" | "de-DE" | "da-DK" | "fr-FR" | "it-IT" | "es-ES";

export const DEFAULT_LOCALE: SupportedLocale = "en-GB";

export const SUPPORTED_LOCALES: SupportedLocale[] = ["en-GB", "en-US", "de-DE", "da-DK", "fr-FR", "it-IT", "es-ES"];

export const LOCALE_STORAGE_KEY = "pw_locale";

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "de-DE": "Deutsch",
    "da-DK": "Dansk",
    "fr-FR": "Français",
    "it-IT": "Italiano",
    "es-ES": "Español",
};

/** ISO 3166-1 alpha-2 country for react-phone-number-input defaultCountry. */
export type PhoneCountryCode = "GB" | "US" | "DE" | "DK" | "FR" | "IT" | "ES";

export const LOCALE_PHONE_COUNTRY: Record<SupportedLocale, PhoneCountryCode> = {
    "en-GB": "GB",
    "en-US": "US",
    "de-DE": "DE",
    "da-DK": "DK",
    "fr-FR": "FR",
    "it-IT": "IT",
    "es-ES": "ES",
};

/** Default phone country flag/calling code for a locale or browser language tag. */
export function localeToPhoneCountry(locale: string | null | undefined): PhoneCountryCode {
    const normalized = normaliseLocaleTag(locale);
    return normalized ? LOCALE_PHONE_COUNTRY[normalized] : "GB";
}

/** Normalise browser or stored tags to a supported locale, or null if no match. */
export function normaliseLocaleTag(tag: string | null | undefined): SupportedLocale | null {
    if (!tag || typeof tag !== "string") return null;
    const trimmed = tag.trim();
    if (!trimmed) return null;

    if ((SUPPORTED_LOCALES as string[]).includes(trimmed)) {
        return trimmed as SupportedLocale;
    }

    const lower = trimmed.toLowerCase();
    if (lower === "en-us") return "en-US";
    if (lower === "en" || lower.startsWith("en-")) return "en-GB";
    if (lower === "de" || lower.startsWith("de-")) return "de-DE";
    if (lower === "da" || lower.startsWith("da-")) return "da-DK";
    if (lower === "fr" || lower.startsWith("fr-")) return "fr-FR";
    if (lower === "it" || lower.startsWith("it-")) return "it-IT";
    if (lower === "es" || lower.startsWith("es-")) return "es-ES";

    return null;
}
